const STORAGE_KEY = "haechieWorldMapLocations";

const CITY_LOOKUP = [
  { keys: ["seoul", "서울"], lat: 37.5665, lng: 126.978 },
  { keys: ["busan", "pusan", "부산"], lat: 35.1796, lng: 129.0756 },
  { keys: ["incheon", "인천"], lat: 37.4563, lng: 126.7052 },
  { keys: ["tokyo", "東京", "도쿄"], lat: 35.6762, lng: 139.6503 },
  { keys: ["osaka", "大阪", "오사카"], lat: 34.6937, lng: 135.5023 },
  { keys: ["beijing", "北京", "베이징"], lat: 39.9042, lng: 116.4074 },
  { keys: ["shanghai", "上海", "상하이"], lat: 31.2304, lng: 121.4737 },
  { keys: ["shenzhen", "深圳"], lat: 22.5431, lng: 114.0579 },
  { keys: ["singapore"], lat: 1.3521, lng: 103.8198 },
  { keys: ["paris"], lat: 48.8566, lng: 2.3522 },
  { keys: ["london"], lat: 51.5074, lng: -0.1278 },
  { keys: ["berlin"], lat: 52.52, lng: 13.405 },
  { keys: ["new york", "nyc"], lat: 40.7128, lng: -74.006 },
  { keys: ["los angeles"], lat: 34.0522, lng: -118.2437 },
  { keys: ["chicago"], lat: 41.8781, lng: -87.6298 },
  { keys: ["houston"], lat: 29.7604, lng: -95.3698 },
  { keys: ["delhi", "new delhi"], lat: 28.6139, lng: 77.209 },
  { keys: ["gurugram", "gurgaon"], lat: 28.4595, lng: 77.0266 },
  { keys: ["mumbai"], lat: 19.076, lng: 72.8777 },
  { keys: ["bangalore", "bengaluru"], lat: 12.9716, lng: 77.5946 },
  { keys: ["hyderabad"], lat: 17.385, lng: 78.4867 },
  { keys: ["pune"], lat: 18.5204, lng: 73.8567 },
  { keys: ["chennai"], lat: 13.0827, lng: 80.2707 },
  { keys: ["seongnam"], lat: 37.4449, lng: 127.1388 },
  { keys: ["pyeongtaek"], lat: 36.994, lng: 127.088 },
  { keys: ["suwon"], lat: 37.2636, lng: 127.0286 },
  { keys: ["dubai"], lat: 25.2048, lng: 55.2708 },
  { keys: ["sydney"], lat: -33.8688, lng: 151.2093 },
];

/** Drop pins saved by the old click-to-place map so they never linger in storage. */
try {
  localStorage.removeItem(STORAGE_KEY);
} catch {
  /* storage unavailable */
}

export const parseLatLngText = (text) => {
  if (!text || typeof text !== "string") return null;
  const labeled = text.match(/(-?\d+(?:\.\d+)?)\s*[,;\s]\s*(-?\d+(?:\.\d+)?)/);
  if (!labeled) return null;
  const lat = Number(labeled[1]);
  const lng = Number(labeled[2]);
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  const looksGeographic = lat < 0 || lng < 0 || lng > 100;
  if (!looksGeographic) return null;
  return { lat, lng };
};

const matchCity = (text) => {
  if (!text) return null;
  const normalized = String(text).toLowerCase();
  const match = CITY_LOOKUP.find((city) => city.keys.some((key) => normalized.includes(key)));
  return match ? { lat: match.lat, lng: match.lng } : null;
};

export const geocodeLocationText = (text) => parseLatLngText(text) || matchCity(text);

const COUNTRY_CODES = {
  KR: { lat: 36.5, lng: 127.8 },
  IN: { lat: 22.5, lng: 79 },
  US: { lat: 39.8, lng: -98.5 },
  MX: { lat: 23.6, lng: -102.5 },
  CN: { lat: 35.8, lng: 104.2 },
  JP: { lat: 36.2, lng: 138.2 },
  DE: { lat: 51.1, lng: 10.4 },
  AU: { lat: -25.3, lng: 133.8 },
};

/** Position comes from the backend site only (lat/lng, else address / site name); map clicks never move it. */
export const resolveDeviceWorldPosition = (device) => {
  if (Number.isFinite(device?.latitude) && Number.isFinite(device?.longitude)) {
    return { lat: device.latitude, lng: device.longitude, source: "site" };
  }
  const siteText = [device?.address, device?.siteName, device?.regionName].filter(Boolean).join(" ");
  const fallbackText = [
    device?.install?.installation_location,
    device?.install?.installation_info,
    device?.city,
    device?.country,
  ]
    .filter(Boolean)
    .join(" ");
  // Street addresses contain house / PIN numbers, so site text is matched by city name only.
  const guessed = matchCity(siteText) || geocodeLocationText(fallbackText);
  if (guessed) return { ...guessed, source: "guess" };
  const code = String(device?.countryCode || device?.country || "").trim().toUpperCase();
  const country = COUNTRY_CODES[code];
  return country ? { ...country, source: "country" } : null;
};
